module.exports = __webpack_public_path__ + "static/app-shot-n-1-3-bb1c69fde6272674a477d3cc06efd516.png";